module.exports = __webpack_public_path__ + "img/Instagram.924cc538.jpg";